var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkles6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 32,
    viewBox: "0 0 96 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "var(--color-accentGold, #FFD95E)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16l2-4 2 4 4 2-4 2-2 4-2-4-4-2 4-2z",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.4;1;0.4",
    dur: "1.8s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "1;1.2;1",
    dur: "1.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48 10l1-2 1 2 2 1-2 1-1 2-1-2-2-1 2-1z",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.9;0.3",
    dur: "2.4s",
    repeatCount: "indefinite",
    begin: "0.3s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84 20l1.5-3 1.5 3 3 1.5-3 1.5-1.5 3-1.5-3-3-1.5 3-1.5z",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.8;0.2",
    dur: "2.1s",
    repeatCount: "indefinite",
    begin: "0.6s"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles6);
export default __webpack_public_path__ + "static/media/sparkles-6.32006435d5e2370334c71d15b6b01139.svg";
export { ForwardRef as ReactComponent };